import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DeepLinkService,
  DeepLinkData,
  ShareableLink,
} from '../../../core/deep-link.service';

@Component({
  selector: 'app-share-button',
  standalone: true,
  imports: [CommonModule],
  template: `
    <button
      (click)="share()"
      [disabled]="isSharing"
      class="inline-flex items-center gap-2 px-3 py-2 text-sm font-medium rounded-lg transition-all duration-200"
      [class.bg-blue-600]="variant === 'primary'"
      [class.text-white]="variant === 'primary'"
      [class.hover:bg-blue-700]="variant === 'primary' && !isSharing"
      [class.bg-gray-100]="variant === 'secondary'"
      [class.text-gray-700]="variant === 'secondary'"
      [class.hover:bg-gray-200]="variant === 'secondary' && !isSharing"
      [class.opacity-50]="isSharing"
      [class.cursor-not-allowed]="isSharing"
      [title]="title"
    >
      @if (isSharing) {
      <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
        <circle
          class="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4"
        ></circle>
        <path
          class="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
      } @else {
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <circle cx="18" cy="5" r="3" />
        <circle cx="6" cy="12" r="3" />
        <circle cx="18" cy="19" r="3" />
        <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
        <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
      </svg>
      }
      {{ text }}
    </button>
  `,
})
export class ShareButtonComponent {
  @Input() deepLinkData?: DeepLinkData;
  @Input() shareableLink?: ShareableLink;
  @Input() variant: 'primary' | 'secondary' = 'secondary';
  @Input() text = 'Compartilhar';
  @Input() title = 'Compartilhar este conteúdo';

  private deepLinkService = inject(DeepLinkService);

  isSharing = false;

  async share() {
    if (this.isSharing) return;

    this.isSharing = true;

    try {
      let linkToShare: ShareableLink;

      if (this.shareableLink) {
        linkToShare = this.shareableLink;
      } else if (this.deepLinkData) {
        linkToShare = this.deepLinkService.generateDeepLink(this.deepLinkData);
      } else {
        // Fallback to current page
        linkToShare = this.deepLinkService.shareCurrentPage();
      }

      await this.deepLinkService.shareLink(linkToShare);
    } catch (error) {
      console.error('Share error:', error);
    } finally {
      this.isSharing = false;
    }
  }
}
